/** Sector de una grafica de tipo tarta/donut. */
export interface ChartSlice {
  name: string;
  value: number;
  /** True solo en el sector sintetico que agrupa la cola. */
  isGrouped?: boolean;
  /** Cuantos elementos originales quedaron dentro del sector agrupado. */
  groupedCount?: number;
}

/**
 * Reduce una lista de sectores a los `maxSlices` mayores y agrupa el resto en
 * uno solo.
 *
 * La cuenta real tiene cientos de dominios: pintarlos todos convertia el donut
 * en una banda de rayas ilegible, con las etiquetas superpuestas. Quedarse con
 * la cabecera y sumar la cola mantiene el total intacto y la grafica legible.
 *
 * Los sectores sin valor se descartan: no aportan area y si ensucian la leyenda.
 */
export function groupSmallSlices(
  slices: ChartSlice[],
  maxSlices: number,
  otherLabel: string
): ChartSlice[] {
  const ordered = slices
    .filter((slice) => slice.value > 0)
    .sort((a, b) => b.value - a.value);

  const fitsWithoutGrouping =
    !Number.isFinite(maxSlices) || maxSlices < 2 || ordered.length <= maxSlices;

  if (fitsWithoutGrouping) {
    return ordered;
  }

  // Se reserva un hueco para el propio sector agrupado.
  const head = ordered.slice(0, maxSlices - 1);
  const tail = ordered.slice(maxSlices - 1);

  return [
    ...head,
    {
      name: otherLabel,
      value: tail.reduce((sum, slice) => sum + slice.value, 0),
      isGrouped: true,
      groupedCount: tail.length,
    },
  ];
}
